export default __webpack_public_path__ + "static/media/Poppins-ExtraLight.305a3ca2.eot";